import { Pipe, PipeTransform } from "@angular/core";
import { MagicMarkdownService } from "./magic-markdown.service";
import { SafeHtml } from "@angular/platform-browser";

/**
 * Used to inline format a chunk of text to include magic symbology.
 * 
 * @example
 * <div [innerHTML]="text | magicmarkdown"></div>
 * 
 * To include one or more parameters:
 * 
 * @example
 * <div [innerHTML]="text | magicmarkdown:true:true"></div>
 */
@Pipe({
    name: 'magicmarkdown',
    standalone: true
})
export class MagicMarkdownPipe implements PipeTransform {
    constructor(private magicMarkdownService: MagicMarkdownService) {

    }

    public transform(value: string, smallSymbols?: boolean, isFlavorText?: boolean): SafeHtml {
        if (!isFlavorText) {
            return this.magicMarkdownService.formatText(value, smallSymbols ?? false);
        } else {
            return this.magicMarkdownService.formatFlavorText(value);
        }
    }
}